import { GeoJson } from '@ais-ui/api-spec/shapes';
import {
  PiCircleThin,
  PiFolderThin,
  PiLineSegmentThin,
  PiMapPinThin,
  PiPolygonThin,
  PiQuestion,
} from 'react-icons/pi';
import { IconType } from 'react-icons';
import { getShapeType } from './getShapeType'; // Import React

export const shapeToIcon = (
  shape: GeoJson
): React.FC<React.SVGProps<SVGSVGElement>> => {
  let IconComponent: IconType | React.FC<React.SVGProps<SVGSVGElement>>; // Use a variable to hold the component
  const shapeType = getShapeType(shape);

  switch (shapeType) {
    case 'FeatureCollection':
      IconComponent = PiFolderThin;
      break;
    case 'Point':
      IconComponent = PiMapPinThin;
      break;
    case 'Circle':
      IconComponent = PiCircleThin;
      break;
    case 'Polygon':
      IconComponent = PiPolygonThin;
      break;
    case 'LineString':
      IconComponent = PiLineSegmentThin;
      break;
    default:
      IconComponent = PiQuestion;
  }

  // Return a functional component that renders the icon
  return (props) => <IconComponent {...props} />;
};
